import { Navigate } from "react-router";
import { isAuthenticated } from "../helpers/auth";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Box } from "@mui/material";

export function PrivateRoute({ children }) {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/home" />;
}

export function PublicRoute({ children }) {
    const auth = isAuthenticated();
    return<>
    <div className='app-container '>

    <Navbar/>
      <Box className='content'>
          {auth ? <Navigate to="/" /> : children}
      </Box>
    <Footer/>
    </div>
    </> 
  }